import BaseContainer from "@base/container/BaseContainer";
import AddComponent from "@base/utils/AddComponent";
import Facade from "@/Facade";
import {Signals} from "@/Imports";
import ScaleManager from "@/stage/ScaleManager";

export default class BuyButtonContainer extends BaseContainer {

    constructor() {
        super()
        this.init()
    }

    init() {
        const stateBtn = {up:'buyFeature/buy_feature_board-up',
                    over:'buyFeature/buy_feature_board_over',
                    down:'buyFeature/buy_feature_board_down',
                    disable:'buyFeature/buy_feature_board-disable'
                    }

        this.container = AddComponent.addContainer(this, { x:700, y:1600})  
        this.animationMask = AddComponent.addSpineAnimation('buy_feature_mask','buy_feature_mask_ani', this.container, [30, -10])
        this.animationMask.scale.x=1.1
        this.animationMask.scale.y=1.1
        this.button = AddComponent.addButton(stateBtn, this.container, [30, 50])
        this.button.scale.x=1.6
        this.button.scale.y=1.6
        this.button.on('tapButton', ()=>{
            this.animationMask.start(['buy_feature_mask_ani'], [false])
            Signals.buyFeatureOpen.dispatch()
        })
        this.button.on('overButton', ()=>{
            this.animationMask.start(['buy_feature_mask_ani'], [false])
        })
        this.button.on('outButton', ()=>{
            this.animationMask.stop(['buy_feature_mask_ani'], [false])
        })
       // this.buttonCaption = AddComponent.addElementTextName('btnBuyFeature',this.button,[0,0])
        this.buttonCaption = AddComponent.addElementText('btnBuyFeature','buyFeature',this.button,[0,2])
        this.buttonCaption.scale.x = 0.79
        this.buttonCaption.scale.y = 0.79

        this.onOrientationChanged(Facade.orientation)

       // this.visible = Facade.model.buyFreebetShow  // TODO : change

        Signals.buyButtonEnabled.add(this.enable, this)
        Signals.buyButtonDisabled.add(this.disable, this)
    }

    enable(){
        this.button.enable()
    }

    disable(){ 
        this.button.disable()
    }

    onOrientationChanged(orientationSymbol) {
        switch ( orientationSymbol ) {
            case 'Hd':
                this.container.position.set(700, 1600)
                break
            case 'Hm':
                this.container.position.set(700, 1600)
                break
            case 'Vm':
                this.container.position.set(960, 2400 + ScaleManager.shiftScaleY)
                break
        }
    }
}

